import type { FC } from "react";
import { ClickableIcon } from "../../primitives";

type ExpansionChevronProps = {
	expanded: boolean;
	onToggle: () => void;
	label: string;
};

export const ExpansionChevron: FC<ExpansionChevronProps> = ({ expanded, onToggle, label }) => (
	<ClickableIcon
		onClick={(e) => {
			e.stopPropagation();
			onToggle();
		}}
		aria-label={`${expanded ? "Collapse" : "Expand"} ${label}`}
		aria-expanded={expanded}
		className="w-5 h-5 rounded-sm hover:bg-surface-light"
		type={expanded ? "chevron-down" : "chevron-right"}
		size="micro"
		color="secondary"
	/>
);
